// import {Platform} from "react-native";
//
// module.exports = Platform.OS === 'android' ? require("react-native-firebase") : null;


/**
 * @providesModule RNRestart
 */

'use strict';


const DeviceInfo  = null;

export default DeviceInfo;
